import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-locked-solid",
  "use": "icon-locked-solid-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-locked-solid\"><path d=\"M12 5h-1V4c0-1.7-1.3-3-3-3S5 2.3 5 4v1H4c-1.1 0-2 .9-2 2v5c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2m-4 6c-.8 0-1.5-.7-1.5-1.5S7.2 8 8 8s1.5.7 1.5 1.5S8.8 11 8 11m2-6H6V4c0-1.1.9-2 2-2s2 .9 2 2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol